//hook
import { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";

//image
import roomImage from "../../assets/images/home_image/room_1.jpg"

//css file
import style from "./Rooms.module.css"

//mui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//component
import RoomCard from "../../Component/RoomCard/RoomCard";
import Booking from "../../popup/Booking";

//tranlsate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

//api
import { GetAllRooms } from "../../api/room/GetAllRooms";

//type
import { allRooms, roomType } from "../../api/room/type/RoomType";

interface RoomPageProps {
  bookingRequest: {cardId: number | null; open: boolean , type: string};
  setBookingRequest: (bookingRequest: {cardId: number | null; open: boolean, type: string}) => void
}
const RoomPage = ({bookingRequest, setBookingRequest} : RoomPageProps) => {
  const {t} = useTranslation()
  const [roomsData, setRoomsData] = useState<allRooms>({
    "Single Rooms": [],
    "Double Rooms": [],
    "Suites": [],
  });
  const {
    loading: roomsLoading,
    error: roomsError,
    HandlerApi: roomsApi
  } = useApi(GetAllRooms, "GET");

  useEffect(() => {
    const fetchData = async () => {
      const rooms = await roomsApi();
      setRoomsData(rooms.data );
    };
    fetchData();
    }, []);

  return (
    <div className={`${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} text-primaryColor bg-[#EDEBDF]`}>
      <div className={`h-[500px] max-md:h-72 relative image ${style.image}`}>
        <img className="w-full h-full object-cover" src={roomImage} alt="no_photo"/>
        <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 translate-y-1/2 text-white md:text-2xl sm:text-sm max-sm:text-[13px]">{t("rooms")}</p>
      </div>
      <div dir={i18n.language === "en" ? "ltr" : "rtl"}>
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className="max-w-[1560px] m-auto gap-[10px] text-center">
          {roomsLoading 
          ? 
          <div className='flex justify-center w-full min-h-[30vh]'>
            <CircularProgress className="m-auto"/>
          </div>
          :
          roomsError
          ?
          <div className='cursor-pointer flex justify-center w-full min-h-[30vh]'>
            <ReplayIcon onClick={roomsApi} className='!text-[40px] m-auto'/>
          </div>
          :
          <>
          <div>
            {
              Object.entries(roomsData).map(([category, rooms]:[string, roomType[]], index) => {
                return (
                  <div key={index}>
                    {/* category name */}
                    <h2 className="sm:text-5xl max-sm:text-2xl m-10">{category}</h2>
                    {/* rooms list */}
                    <div className="grid md:grid-cols-3 grid-cols-1 gap-5">
                      {rooms.map((element, index) => (
                        <RoomCard key={index} element={element} setBookingRequest={setBookingRequest}/>
                      ))}
                    </div>
                  </div>
                );
              })
            }
          </div>
          </>
          }
        </Box>
        <Booking bookingRequest={bookingRequest} setBookingRequest={setBookingRequest}/>
      </div>
    </div>
  )
}

export default RoomPage
